/**
 * Aplicación web Directorio del Ayuntamiento de Zamora.
 * 
 * Desarrollo e implementación: Jaime León Pereira.
 * Ingeniero Informático de la Unidad TIC.
 */
import { Link } from 'react-router-dom';

/**
 * Página de error 404 - Página no encontrada.
 * 
 * Muestra un mensaje de error cuando el usuario intenta acceder
 * a una ruta que no existe en la aplicación.
 */
function NotFoundPage() {
  return (    
    <div
      className="d-flex flex-column justify-content-center align-items-center text-center"
      style={{ height: "80vh" }}
    >
      <h1 className="text-danger">404 - PÁGINA NO ENCONTRADA</h1>
      <Link to="/" className="btn btn-secondary">Volver al inicio</Link>
    </div>
  );
}

export default NotFoundPage;
